import React from 'react';
import Link from '../common/Link';
import { ReactComponent as ArrowLeft } from 'assets/img/arrow-left.svg';
import CompareTractsStatsSelector from './CompareTractsStatsSelector';

export default function CompareTractsSidePanel({
  children: _children,
  activeTract,
  backLinkAction,
  items,
  searchQuery,
  searchResults,
  setSearchQuery,
  isSearchResultsLoading,
  updateSelected,
  activeCompareTract,
}) {
  return (
    <div data-component-name='CompareTractsSidePanel' className='h-full'>
      <div className='flex flex-col h-full text-blue-600'>
        {backLinkAction && (
          <Link
            action={backLinkAction}
            icon={<ArrowLeft />}
            isIconLeft={true}
            color='text-blue-500/60'
          >
            <span className='text-base -translate-y-px'>back</span>
          </Link>
        )}

        <h2 className='pb-4 mt-4 text-lg font-bold'>Compare tracts</h2>

        <div className='h-full overflow-auto pb-7'>
          <div className='h-full pt-2'>
            <CompareTractsStatsSelector
              activeTract={activeTract}
              items={items}
              searchQuery={searchQuery}
              searchResults={searchResults}
              setSearchQuery={setSearchQuery}
              isSearchResultsLoading={isSearchResultsLoading}
              updateSelected={updateSelected}
              activeCompareTract={activeCompareTract}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
